export var PreferencesServiceEvent;
(function (PreferencesServiceEvent) {
    PreferencesServiceEvent["LocalPreferencesChanged"] = "LocalPreferencesChanged";
    PreferencesServiceEvent["PreferencesChanged"] = "PreferencesChanged";
})(PreferencesServiceEvent || (PreferencesServiceEvent = {}));
